// @ts-nocheck
export const primary = {
  main: '#3f51b5',
  light: '#7986cb',
  dark: '#303f9f',
  contrastText: '#ffffff',
  borderColor: '#8AA4D180',
  backgroundColor: '#6386C214',
  textColor: '#233759',
};
export const secondary = {
  main: '#FBAD33',
  light: '#FAC96B',
  dark: '#F0840F',
  contrastText: '#ffffff',
  borderColor: '#FBAD3380',
  backgroundColor: '#FBAD3314',
};

export const error = {
  main: '#f44336',
  light: '#e57373',
  dark: '#d32f2f',
  contrastText: '#ffffff',
  textColor: '#000000DE',
  backgroundColor: '#000000DE',
};

export const warning = {
  main: '#ff9800',
  light: '#ffb74d',
  dark: '#f57c00',
  contrastText: '#000000DE',
  textColor: '#00000099',
  backgroundColor: '#FFFFFFE5',
};

export const info = {
  main: '#2196f3',
  light: '#64b5f6',
  dark: '#1976d2',
  contrastText: '#ffffff',
  textColor: '#00000099',
  backgroundColor: '#FFFFFFE5',
  lightBackgroundColor: '#d3eafd',
};

export const success = {
  main: '#4caf50',
  light: '#81c784',
  dark: '#388e3c',
  contrastText: 'rgba(0, 0, 0, 0.87)',
  textColor: '#00000099',
  backgroundColor: '#FFFFFFE5',
  lightColor: 'rgba(219, 239, 220, 1)',
};

export const normalText = {
  main: '#212529',
  light: '#5F6D83',
  dark: '#6A737B',
  lightGrey: '#98A5B9',
  backgroundColor: '#FFF4E3',
  lightColor: '#eaedf1',
};
